import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useCookies } from 'react-cookie';

import Modal from '../components/Modal';
import Button from '../components/Button';
import ConditionalRendering from '../components/ConditionalRendering';

import DownloadProgramForm from '../DownloadProgramForm';
import DownloadProgramSocialProof from '../DownloadProgramSocialProof';
import DownloadProgramThankYou from '../DownloadProgramThankYou';

const defaultProps = {
  config: {
    production: false,
  },
};

const propTypes = {
  config: PropTypes.shape({
    production: PropTypes.bool,
  }),
};

const DownloadProgram = ({
  config: {
    production,
  },
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [success, setSuccess] = useState(false);
  const [cookies] = useCookies(['hubspotutk']);

  const onFormSubmit = useCallback((isSubmitting) => {
    setDisabled(isSubmitting);
  }, []);

  const onFormSuccess = useCallback(() => {
    setSuccess(true);
  }, []);

  const onDownload = useCallback(() => {
    setOpenModal(false);
  }, []);

  return (
    <>
      <Button
        type="button"
        className="text-gray-900 w-full block py-4 rounded font-bold underline focus:outline-none lg:inline-flex"
        onClick={() => setOpenModal(true)}
      >
        Descargar programa
      </Button>
      <Modal
        isOpen={openModal}
        noPadding
        disabled={disabled}
        leftContent={<DownloadProgramSocialProof />}
        onClose={() => setOpenModal(false)}
      >
        <ConditionalRendering on={!success}>
          <DownloadProgramForm
            onSubmit={onFormSubmit}
            onSuccess={onFormSuccess}
            disabled={!production}
            cookie={cookies.hubspotutk}
          />
        </ConditionalRendering>
        <ConditionalRendering on={success}>
          <DownloadProgramThankYou
            onDownload={onDownload}
          />
        </ConditionalRendering>
      </Modal>
    </>
  );
};

DownloadProgram.defaultProps = defaultProps;
DownloadProgram.propTypes = propTypes;

export default DownloadProgram;
